export * from './pricespider-config.provider';
